import { render } from "./ProductsCategory.vue?vue&type=template&id=ca5bb5fa"
import script from "./ProductsCategory.vue?vue&type=script&lang=js"
export * from "./ProductsCategory.vue?vue&type=script&lang=js"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__